<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Heart" class="d-icon d-icon--heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><g :clip-path="`url(#${uniqueID}a)`"><path fill="currentColor" fill-rule="evenodd" d="M2.476 1.24a3.2 3.2 0 0 1 3.493.697l.002.002.03.03.028-.03.002-.002a3.2 3.2 0 0 1 4.533 0c1.273 1.273 1.3 3.377-.207 4.913l-.003.004-4 4a.5.5 0 0 1-.707 0L1.643 6.85C.136 5.314.163 3.21 1.436 1.937a3.2 3.2 0 0 1 1.04-.696Zm1.227.756a2.2 2.2 0 0 0-1.559.647c-.846.847-.949 2.322.211 3.505L6 9.793l3.645-3.645c1.16-1.183 1.059-2.658.212-3.504a2.204 2.204 0 0 0-2.403-.48 2.2 2.2 0 0 0-.714.478v.001l-.384.388a.5.5 0 0 1-.712 0l-.383-.388a2.2 2.2 0 0 0-1.558-.647Z" clip-rule="evenodd"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHeart',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
